<template>
  <div class="profile-card">
    <div v-if="profiles.seeker.status == 'Approved'">
      <div class="cv-search-control">
        <label class="switch">
          <input
            @click="CheckEX()"
            type="checkbox"
            v-model="profiles.seeker.showStatus"
            value="false"
          />
          <span class="slider round"></span>
        </label>

        <p v-if="profiles.seeker.showStatus == true">Showing on CV Search</p>
        <p v-else>Hiding on CV Search</p>
      </div>
    </div>
    <div class="profile-image">
      <img :src="profiles.seeker.registerSeeker.fileId.src" />
    </div>
    <div class="profile-info" v-if="profiles.seeker">
      <h3>
        {{ profiles.seeker.registerSeeker.firstName }}
        {{ profiles.seeker.registerSeeker.lastName }}
      </h3>
      <p>
        {{ moment(profiles.seeker.registerSeeker.dateOfBirth) }} |
        {{ profiles.seeker.registerSeeker.maritalStatusId.name }}
      </p>
      <p>020 {{ profiles.seeker.authId.mobile }}</p>
      <p>{{ profiles.seeker.authId.email }}</p>
      <p v-if="profiles.seeker.resume.workingExperience">
        {{ profiles.seeker.resume.workingExperience.totalWorkingExperience }}
        Years Experience
      </p>

      <a
        download
        :href="profiles.seeker.resume.fileId.src"
        class="button primary"
        >Download Resume</a
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { apolloClient } from "@/services/apollo-client";
import { CHECK_EX } from "@/graphql/seeker/seeker";
export default {
  props: ["profiles"],
  data: () => ({}),
  filters: {},
  methods: {
    moment(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    async CheckEX() {
      const res = await apolloClient.mutate({
        mutation: CHECK_EX,
        variables: {
          seekerId: this.profiles.seeker._id,
        },
      });
      this.profiles.seeker.showStatus = res.data.checkSeeker.showStatus;
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-card {
  border: 1px solid var(--border-color);
  position: relative;
  padding: 20px;
  .profile-image {
    margin: 0 auto;
    max-width: 100px;
    max-height: 100px;
    min-width: 100px;
    min-height: 100px;
    background-size: cover;
    object-fit: cover;
    overflow: hidden;
    border-radius: 50%;
    border: 2px solid var(--primary-color);
  }
  .profile-info {
    margin-top: 10px;
    text-align: center;
    h3 {
      font-size: 18px;
      font-weight: 700;
      margin: 0;
      line-height: 1.8;
    }
    p {
      font-size: 14px;
      margin: 0;
      cursor: pointer;
      line-height: 1.8;
    }
    .button {
      margin-top: 10px;
      border: 1px solid var(--primary-color);
      background-color: var(--primary-color);
      color: #fff;
      border-radius: 0;
      &:focus {
        outline: none;
        box-shadow: none;
        box-shadow: unset;
      }
    }
  }
}

.cv-search-control {
  display: flex;
  align-items: center;
  gap: 10px;
  label {
    margin-bottom: 0;
  }
  p {
    margin: 0;
  }
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  margin-bottom: 10px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--light-grey-color);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: var(--primary-color);
}

input:checked + .slider:before {
  -webkit-transform: translateX(23px);
  -ms-transform: translateX(23px);
  transform: translateX(23px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 28px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
